import { bebop as bebopApi } from 'core/api/definitions/bebop';

import { getOffset } from 'core/utils/url-helper';
import { renderError } from 'core/utils/app-status-helper';
import { throwIfHistoryIsMissing } from 'core/utils/query';

export const limit = 20;


export const rawAuthorsQuery = queryParams => {
  throwIfHistoryIsMissing(queryParams, 'rawAuthorsQuery in authorsPage.js');

  const {
    location,
    history,
  } = queryParams;

  return {
    queryKey: ['bebopApi', 'getAuthors', {
      with_filtered_count: 1,
      offset: getOffset(location.search, limit),
      limit,
    }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params).catch(err => renderError(err, history)),
  };
};
